module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/logo_banner/image 021-e7b81b17f66b21efa0c946903e234c92.png";